enum SearchActionType {
  SEARCH_ENTRIES = 'search/SEARCH_ENTRIES',
  SEARCHING_ENTRIES = 'search/SEARCHING_ENTRIES',
  SEARCHED_ENTRIES = 'search/SEARCHED_ENTRIES',
  SEARCH_ENTRIES_FAILED = 'search/SEARCH_ENTRIES_FAILED',
  RESET_SEARCH_ENTRIES = 'search/RESET_SEARCH_ENTRIES',
}

export default SearchActionType;
